export default [
  {
    value: "poor",
    label: "Poor",
  },
  {
    value: "middleClass",
    label: "Middle Class",
  },
  {
    value: "orphan",
    label: "Orphan",
  },
  {
    value: "widow",
    label: "Widow",
  },
  {
    value: "widower",
    label: "Widower",
  },
  {
    value: "homeless",
    label: "Homeless",
  },
  {
    value: "nearHomeless",
    label: "Near Homeless",
  },
  {
    value: "notHomeless",
    label: "Not Homeless",
  },
  {
    value: "employed",
    label: "Employed",
  },
  {
    value: "unemployed",
    label: "Unemployed",
  },
  {
    value: "lowIncome",
    label: "Low Income",
  },
  {
    value: "highIncome",
    label: "High Income",
  },
  {
    value: "averageIncome",
    label: "Average Income",
  },
  {
    value: "insured",
    label: "Insured",
  },
  {
    value: "underInsured",
    label: "Under Insured",
  },
  {
    value: "notInsured",
    label: "Not Insured",
  },
  {
    value: "individual",
    label: "Individual",
  },
  {
    value: "smallFamily",
    label: "Small Family",
  },
  {
    value: "largeFamily",
    label: "Large Family",
  },
];
